module.exports = __webpack_public_path__ + "static/media/t2.268650be.png";